<template>
  <DialogCard :title="theTitle" :actions="actions">
    <v-card-text>Are you sure you wish to apply these changes?</v-card-text>
    <v-expansion-panels >
    <v-expansion-panel>
        <v-expansion-panel-header>Show Technical Details</v-expansion-panel-header>
        <v-expansion-panel-content>
          <vue-json-compare :oldData="oldData" :newData="newData"></vue-json-compare>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    

  </DialogCard>
</template>
<script>
import VueJsonCompare from 'vue-json-compare';

export default {
  name: "ConfirmUpdateDialog",
  components: {VueJsonCompare},
  props: {
    oldData: Object,
    newData: Object,

  },
  data() {
    return {
    };
  },
  created: function() {
  },
  computed: {
    theTitle: function () {
      return `Confirm Update`;
    },
    actions: function () {
      return {
        cancel: {
          text: "Cancel",
          color: "secondary",
          handle: () => {
            return {  action: "cancelled" };
          },
        },
        ok: {
          text: "OK",
          color: "primary",
          handle: async () => {
            return {
              action: "ok",
            };
          },
        },
      };
    },
  },
  methods: {
   
  },
};
</script>